import type { BadgeVariant } from '../../../shared/ui/Badge';
import type { SuperadminOrganizationRowDto, SuperadminOrgLifecycleStatus } from '../api/organizations.types';

export type { SuperadminOrgLifecycleStatus } from '../api/organizations.types';

export function parseOrgLifecycleStatus(raw: unknown): SuperadminOrgLifecycleStatus | null {
  if (typeof raw !== 'string') return null;
  switch (raw) {
    case 'active':
    case 'no_plan':
    case 'vip_no_payment':
    case 'grace':
    case 'expired':
    case 'removed':
      return raw;
    default:
      return null;
  }
}

export function orgLifecycleBadgeVariant(status: SuperadminOrgLifecycleStatus): BadgeVariant {
  switch (status) {
    case 'active':
      return 'success';
    case 'no_plan':
      return 'warning';
    case 'vip_no_payment':
      return 'primary';
    case 'grace':
      return 'warning';
    case 'expired':
      return 'danger';
    case 'removed':
      return 'neutral';
    default:
      return 'neutral';
  }
}

/** Подпись / tooltip для иконки «тариф» в строке таблицы организаций (только no_plan / grace / expired). */
export function orgLifecyclePlanRowActionAriaLabel(row: SuperadminOrganizationRowDto): string | null {
  const s = row.status ?? 'active';
  if (s === 'no_plan') return 'Назначить тариф';
  if (s === 'vip_no_payment') return 'Сбросить VIP или сменить тариф';
  if (s === 'expired' || s === 'grace') return 'Проверить тариф';
  return null;
}

/** См. `orgLifecyclePlanRowActionAriaLabel` — единая подпись для иконки тарифа в строке. */
export function orgLifecycleQuickActionLabel(row: SuperadminOrganizationRowDto): string | null {
  return orgLifecyclePlanRowActionAriaLabel(row);
}
